import { render, staticRenderFns } from "./NewPatternCategory.vue?vue&type=template&id=9050623a&scoped=true&"
import script from "./NewPatternCategory.vue?vue&type=script&lang=js&"
export * from "./NewPatternCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewPatternCategory.vue?vue&type=style&index=0&id=9050623a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9050623a",
  null
  
)

export default component.exports